module.exports = __webpack_public_path__ + "static/media/NE.13e02dc6.svg";